import React from 'react';
import {GridColDef} from '@mui/x-data-grid-pro';
import {themeColors} from '../../../theme/Theme';
import {RenderColor} from '../../../components/EditorGrid/GridRenderComponents';
import {Task} from '../../../schema-types/Task';
import {TaskUrgencyEnum} from '../../../schema-types/globalTypes';

export const valueGetterStatus = (params: never, row: Task) => {
  if (row.isFailedSubmission) {
    return 'Error';
  }
  return row.curoId ? 'Submitted' : 'Draft';
};

export const valueGetterActivitySubGroup = (params: never, row: Task) =>
  row.activitySubGroup?.name || 'Task Error';

export const valueGetterDescription = (params: never, row: Task) =>
  row.description || 'This task has returned an error';

export const valueGetterOwner = (params: never, row: Task) => row.owner?.name || 'Error';

export const valueGetterUrgent = (params: never, row: Task) => {
  switch (row.urgency) {
    case TaskUrgencyEnum.TYE:
      return 'Tax year ending';
    case TaskUrgencyEnum.TAX_YEAR_SENSITIVE:
      return 'Tax year sensitive';
    case TaskUrgencyEnum.URGENT:
      return 'Urgent';
    case TaskUrgencyEnum.NORMAL:
      return 'Normal';
    default:
      return undefined;
  }
};

export const tasksColumns: GridColDef[] = [
  {
    field: 'status',
    sortable: false,
    headerName: 'Status',
    width: 120,
    editable: false,
    headerAlign: 'center',
    disableColumnMenu: true,
    renderCell: RenderColor({
      Submitted: themeColors.lightGreen,
      Draft: themeColors.greyLight,
      Error: themeColors.red,
    }),
    valueGetter: valueGetterStatus,
  },
  {
    field: 'activitySubGroup',
    sortable: false,
    headerName: 'Task',
    flex: 1,
    editable: false,
    headerAlign: 'center',
    disableColumnMenu: true,
    valueGetter: valueGetterActivitySubGroup,
  },
  {
    field: 'description',
    sortable: false,
    headerName: 'Name',
    flex: 2,
    editable: false,
    headerAlign: 'center',
    disableColumnMenu: true,
    valueGetter: valueGetterDescription,
    renderCell: (params) => (
      <div style={{whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5'}}>
        {params.value}
      </div>
    ),
  },
  {
    field: 'owner',
    sortable: false,
    headerName: 'Assigned to',
    width: 120,
    editable: false,
    headerAlign: 'center',
    disableColumnMenu: true,
    valueGetter: valueGetterOwner,
  },
  {
    field: 'urgency',
    sortable: false,
    headerName: 'Urgency',
    width: 120,
    editable: false,
    headerAlign: 'center',
    disableColumnMenu: true,
    renderCell: RenderColor({
      Normal: themeColors.greyLight,
      'Tax year sensitive': themeColors.lightBlue,
      Urgent: themeColors.lightWarning,
      Error: themeColors.lightAlert,
    }),
    valueGetter: valueGetterUrgent,
  },
];
